const ICON_ALIASES = {
  // Nombres semánticos de la aplicación.
  add: 'plus',
  back: 'arrow-left',
  bookmark: 'bookmark',
  'bookmark-filled': 'bookmark-fill',
  calendar: 'calendar',
  cart: 'cart',
  chat: 'chat-dots',
  close: 'x',
  code: 'code-slash',
  dashboard: 'grid',
  database: 'server',
  delete: 'trash',
  download: 'download',
  edit: 'pencil-square',
  external: 'box-arrow-up-right',
  filter: 'filter',
  folder: 'folder2-open',
  forward: 'arrow-right',
  history: 'clock',
  info: 'info-circle',
  lock: 'lock',
  mail: 'envelope',
  money: 'cash-stack',
  notifications: 'bell',
  people: 'people',
  print: 'printer',
  refresh: 'arrow-repeat',
  reports: 'file-earmark-text',
  save: 'check2-circle',
  search: 'search',
  settings: 'gear',
  shortcuts: 'star',
  tasks: 'check2-square',
  tools: 'tools',
  unlock: 'unlock',
  user: 'person',
  visibility: 'eye',
  'visibility-off': 'eye-slash',

  // Compatibilidad con los metadatos actuales del backend y CoreUI.
  'fa-address-book': 'person-lines-fill',
  'fa-angle-double-left': 'chevron-double-left',
  'fa-angle-double-right': 'chevron-double-right',
  'fa-angle-down': 'chevron-down',
  'fa-angle-left': 'chevron-left',
  'fa-angle-right': 'chevron-right',
  'fa-angle-up': 'chevron-up',
  'fa-arrow-left': 'arrow-left',
  'fa-arrow-right': 'arrow-right',
  'fa-archive': 'archive',
  'fa-balance-scale': 'bar-chart',
  'fa-bank': 'building',
  'fa-bar-chart': 'bar-chart',
  'fa-bell': 'bell',
  'fa-bell-o': 'bell',
  'fa-bolt': 'lightning',
  'fa-bookmark': 'bookmark-fill',
  'fa-bookmark-o': 'bookmark',
  'fa-box': 'box',
  'fa-briefcase': 'briefcase',
  'fa-building': 'building',
  'fa-bullhorn': 'megaphone',
  'fa-bullseye': 'bullseye',
  'fa-calculator': 'calculator',
  'fa-calendar': 'calendar',
  'fa-cart-arrow-down': 'cart',
  'fa-cart-plus': 'cart-plus',
  'fa-chain-broken': 'link',
  'fa-check': 'check2',
  'fa-check-double': 'check2-all',
  'fa-check-circle': 'check2-circle',
  'fa-check-square-o': 'check2-square',
  'fa-circle': 'circle-fill',
  'fa-circle-o': 'circle',
  'fa-circle-thin': 'circle',
  'fa-clock-o': 'clock',
  'fa-clipboard': 'clipboard',
  'fa-close': 'x',
  'fa-cloud': 'cloud',
  'fa-code': 'code-slash',
  'fa-cog': 'gear',
  'fa-cogs': 'gear-wide-connected',
  'fa-comment': 'chat',
  'fa-commenting': 'chat-dots',
  'fa-comments': 'chat-dots',
  'fa-comments-o': 'chat-dots',
  'fa-credit-card': 'credit-card',
  'fa-credit-card-alt': 'credit-card',
  'fa-copy': 'files',
  'fa-cube': 'box',
  'fa-cubes': 'box',
  'fa-dashboard': 'speedometer2',
  'fa-database': 'server',
  'fa-desktop': 'display',
  'fa-dollar': 'currency-dollar',
  'fa-download': 'download',
  'fa-edit': 'pencil-square',
  'fa-envelope': 'envelope',
  'fa-envelope-o': 'envelope',
  'fa-exchange': 'arrow-left-right',
  'fa-exclamation-triangle': 'exclamation-triangle',
  'fa-eye': 'eye',
  'fa-eye-slash': 'eye-slash',
  'fa-file': 'file-earmark',
  'fa-file-excel-o': 'file-earmark-spreadsheet',
  'fa-file-text-o': 'file-earmark-text',
  'fa-files-o': 'files',
  'fa-filter': 'filter',
  'fa-flag-checkered': 'flag',
  'fa-folder-open': 'folder2-open',
  'fa-folder-open-o': 'folder2-open',
  'fa-graduation-cap': 'book',
  'fa-google': 'search',
  'fa-hand-o-up': 'hand-index',
  'fa-hand-paper-o': 'hand-index',
  'fa-handshake-o': 'people',
  'fa-history': 'clock',
  'fa-hashtag': 'hash',
  'fa-id-badge': 'person-badge',
  'fa-id-card-o': 'person-badge',
  'fa-info': 'info-circle',
  'fa-info-circle': 'info-circle',
  'fa-key': 'key',
  'fa-line-chart': 'graph-up',
  'fa-level-down': 'arrow-down',
  'fa-level-up': 'arrow-up',
  'fa-lightbulb-o': 'lightbulb',
  'fa-link': 'link',
  'fa-linux': 'terminal',
  'fa-list': 'list-ul',
  'fa-list-alt': 'list-ul',
  'fa-lock': 'lock',
  'fa-map-marker': 'geo-alt',
  'fa-mobile': 'phone',
  'fa-mobile-phone': 'phone',
  'fa-money': 'cash-stack',
  'fa-newspaper-o': 'newspaper',
  'fa-paint-brush': 'brush',
  'fa-paperclip': 'paperclip',
  'fa-pencil': 'pencil-square',
  'fa-plus': 'plus',
  'fa-percent': 'percent',
  'fa-print': 'printer',
  'fa-puzzle-piece': 'puzzle',
  'fa-qrcode': 'upc-scan',
  'fa-question-circle': 'question-circle',
  'fa-random': 'shuffle',
  'fa-refresh': 'arrow-repeat',
  'fa-repeat': 'arrow-repeat',
  'fa-rocket': 'lightning',
  'fa-save': 'check2-circle',
  'fa-search': 'search',
  'fa-send': 'cursor',
  'fa-server': 'server',
  'fa-shield': 'shield-check',
  'fa-share-alt': 'share',
  'fa-shopping-basket': 'basket',
  'fa-shopping-cart': 'cart',
  'fa-sitemap': 'diagram3',
  'fa-slideshare': 'people',
  'fa-square-o': 'square',
  'fa-suitcase': 'briefcase',
  'fa-tachometer': 'speedometer2',
  'fa-table': 'table',
  'fa-tags': 'tags',
  'fa-tasks': 'check2-square',
  'fa-ticket': 'ticket',
  'fa-th-large': 'grid',
  'fa-thumbs-down': 'hand-thumbs-down',
  'fa-thumbs-up': 'hand-thumbs-up',
  'fa-trash': 'trash',
  'fa-times-circle': 'x-circle',
  'fa-truck': 'truck',
  'fa-university': 'building',
  'fa-unlock': 'unlock',
  'fa-user': 'person',
  'fa-user-secret': 'person',
  'fa-users': 'people',
  'fa-whatsapp': 'chat-dots',
  'fa-window-close': 'x',
  'fa-window-maximize': 'arrows-fullscreen',
  'fa-windows': 'window',
  'fa-wpforms': 'ui-checks',
  'fa-wrench': 'tools',

  'icon-calculator': 'calculator',
  'icon-docs': 'files',
  'icon-feed': 'rss',
  'icon-lock': 'lock',
  'icon-people': 'people',
  'icon-refresh': 'arrow-repeat',
  'icon-speedometer': 'speedometer2',
  'icon-user': 'person',
  'cui-chevron-right': 'chevron-right',
  'cui-dashboard': 'speedometer2',
}

// Traducción del vocabulario histórico de Bootstrap/Font Awesome al
// vocabulario único de Material Symbols. Esta capa permite cambiar el motor
// visual sin cambiar lo que envía el backend ni cada componente consumidor.
const MATERIAL_SYMBOLS = {
  alarm: 'alarm',
  'alarm-fill': 'alarm_on',
  archive: 'archive',
  'arrow-counterclockwise': 'restore',
  'arrow-down': 'arrow_downward',
  'arrow-left': 'arrow_back',
  'arrow-left-right': 'swap_horiz',
  'arrow-repeat': 'refresh',
  'arrow-right': 'arrow_forward',
  'arrow-right-circle-fill': 'arrow_circle_right',
  'arrow-up': 'arrow_upward',
  'arrow-up-circle-fill': 'arrow_circle_up',
  'arrows-fullscreen': 'fullscreen',
  'arrows-move': 'open_with',
  at: 'alternate_email',
  'bar-chart': 'bar_chart',
  basket: 'shopping_basket',
  bell: 'notifications',
  'bell-fill': 'notifications',
  binoculars: 'search_insights',
  blank: '',
  book: 'menu_book',
  bookmark: 'bookmark',
  'bookmark-fill': 'bookmark',
  box: 'inventory_2',
  'box-arrow-right': 'logout',
  'box-arrow-up-right': 'open_in_new',
  'box-seam': 'inventory_2',
  braces: 'data_object',
  briefcase: 'business_center',
  brush: 'brush',
  building: 'apartment',
  bullseye: 'adjust',
  calculator: 'calculate',
  calendar: 'calendar_month',
  cart: 'shopping_cart',
  'cart-plus': 'add_shopping_cart',
  'cash-stack': 'payments',
  chat: 'chat',
  'chat-dots': 'chat',
  'chat-dots-fill': 'chat',
  'chat-square-text': 'chat',
  check: 'check',
  check2: 'check',
  'check2-all': 'done_all',
  'check2-circle': 'check_circle',
  'check2-square': 'check_box',
  'chevron-double-left': 'keyboard_double_arrow_left',
  'chevron-double-right': 'keyboard_double_arrow_right',
  'chevron-down': 'keyboard_arrow_down',
  'chevron-left': 'keyboard_arrow_left',
  'chevron-right': 'keyboard_arrow_right',
  'chevron-up': 'keyboard_arrow_up',
  circle: 'circle',
  'circle-fill': 'circle',
  clipboard: 'content_paste',
  clock: 'schedule',
  'clock-history': 'history',
  cloud: 'cloud',
  code: 'code',
  'code-slash': 'code_off',
  'credit-card': 'credit_card',
  'currency-dollar': 'attach_money',
  cursor: 'send',
  database: 'database',
  diagram3: 'account_tree',
  'diagram-3': 'account_tree',
  display: 'desktop_windows',
  download: 'download',
  envelope: 'mail',
  eraser: 'cleaning_services',
  'eraser-fill': 'cleaning_services',
  'exclamation-circle': 'error',
  'exclamation-triangle': 'warning',
  'exclamation-triangle-fill': 'warning',
  eye: 'visibility',
  'eye-slash': 'visibility_off',
  file: 'draft',
  'file-earmark': 'draft',
  'file-earmark-spreadsheet': 'table_view',
  'file-earmark-text': 'description',
  files: 'file_copy',
  filter: 'filter_alt',
  'filter-alt-off': 'filter_alt_off',
  filter_alt_off: 'filter_alt_off',
  funnel: 'filter_alt',
  'funnel-fill': 'filter_alt',
  flag: 'flag',
  folder: 'folder_open',
  'folder-fill': 'folder',
  'folder2-open': 'folder_open',
  gear: 'settings',
  'gear-wide-connected': 'settings',
  'geo-alt': 'location_on',
  'geo-alt-fill': 'location_on',
  'graph-up': 'trending_up',
  grid: 'grid_view',
  'grid-fill': 'apps',
  grid1x2: 'dashboard_customize',
  'grid3x3-gap': 'apps',
  'hand-index': 'touch_app',
  'hand-thumbs-down': 'thumb_down',
  'hand-thumbs-up': 'thumb_up',
  hash: 'tag',
  'hdd-rack': 'dns',
  inbox: 'inbox',
  'info-circle': 'info',
  kanban: 'view_kanban',
  key: 'key',
  'key-fill': 'key',
  'layout-three-columns': 'view_column',
  lightbulb: 'lightbulb',
  lightning: 'bolt',
  link: 'link',
  'link-45deg': 'link',
  'list-nested': 'list_alt',
  'list-ul': 'format_list_bulleted',
  lock: 'lock',
  'lock-fill': 'lock',
  mail: 'mail',
  megaphone: 'campaign',
  newspaper: 'newspaper',
  notifications: 'notifications',
  paperclip: 'attach_file',
  'pencil-square': 'edit',
  people: 'groups',
  percent: 'percent',
  person: 'person',
  'person-badge': 'badge',
  'person-fill': 'account_circle',
  'person-lines-fill': 'contact_page',
  phone: 'smartphone',
  plus: 'add',
  'plus-circle': 'add_circle',
  'plus-lg': 'add',
  print: 'print',
  printer: 'print',
  puzzle: 'extension',
  'question-circle': 'help',
  receipt: 'receipt_long',
  reports: 'description',
  rss: 'rss_feed',
  search: 'search',
  server: 'dns',
  share: 'share',
  'shield-check': 'verified_user',
  'shield-lock-fill': 'admin_panel_settings',
  shortcuts: 'star',
  shuffle: 'shuffle',
  speedometer2: 'speed',
  square: 'crop_square',
  star: 'star',
  'star-fill': 'star',
  sun: 'light_mode',
  table: 'table_rows',
  tag: 'label',
  tags: 'sell',
  ticket: 'confirmation_number',
  tasks: 'task_alt',
  terminal: 'terminal',
  'toggle-off': 'toggle_off',
  'toggle-on': 'toggle_on',
  tools: 'build',
  trash: 'delete',
  truck: 'local_shipping',
  'ui-checks': 'checklist',
  unlock: 'lock_open',
  'unlock-fill': 'lock_open',
  'upc-scan': 'qr_code_scanner',
  visibility: 'visibility',
  'visibility-off': 'visibility_off',
  window: 'web',
  x: 'close',
  'x-circle': 'cancel',
}

const LEGACY_PREFIXES = ['fa-', 'icon-', 'cil-', 'cui-']

function normalize(value) {
  return String(value || '').trim()
}

export function getIconToken(value) {
  const source = normalize(value)
  if (!source) return ''

  const tokens = source.split(/\s+/)
  return tokens.find(token => LEGACY_PREFIXES.some(prefix => token.indexOf(prefix) === 0)) || source
}

export function isLegacyIcon(value) {
  const token = getIconToken(value)
  return LEGACY_PREFIXES.some(prefix => token.indexOf(prefix) === 0)
}

export function resolveAppIcon(value) {
  const source = normalize(value)
  if (!source) return ''

  const token = getIconToken(source)
  const canonical = ICON_ALIASES[token] || ICON_ALIASES[source] || source

  if (Object.prototype.hasOwnProperty.call(MATERIAL_SYMBOLS, canonical)) {
    return MATERIAL_SYMBOLS[canonical]
  }

  // Los nombres Material directos también son válidos. Si llega una clase
  // heredada aún no catalogada, se usa un símbolo neutro en vez de mezclar
  // nuevamente otra fuente de iconos.
  if (isLegacyIcon(source) || source.indexOf(' ') !== -1) return 'widgets'
  return canonical.replace(/-/g, '_')
}

export function getIconUtilityClasses(value) {
  const source = normalize(value)
  if (!source) return []

  return source.split(/\s+/).filter(token => {
    if (token === 'fa' || token === 'fas' || token === 'far' || token === 'fab') return false
    return !LEGACY_PREFIXES.some(prefix => token.indexOf(prefix) === 0)
  })
}

export { ICON_ALIASES, MATERIAL_SYMBOLS }
